<div class="drug-info-table-parent"></div>
